export default "__VITE_ASSET__CUTCwNzC__"